import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Buttons = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x4};
  margin-inline-start: 0px !important;
`;

export const Button = styled.button`
  background-color: #fff !important;
  border: 1px solid #588af0;
  color: #588af0;
`;
